import React, { useRef } from 'react'
import'./home.css'
import Slideshow from './Slideshow/slideshow'
import {BsFacebook, BsDiscord} from 'react-icons/bs'
import {RiInstagramFill} from 'react-icons/ri'
import { Link } from 'react-router-dom'

const Home = () => {
  const ref = useRef(null);

  const handleClick = () => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className='home__container'>
      {/* Hero Section with Mission Overlay */}
      <div className='hero-section'>
        <Slideshow id='slideshow'/>
        <div className='hero-overlay'>
          <div className='mission-content'>
            <h1 className='mission-title'>Women in Computing @ UW</h1>
            <p className='mission-statement'>
              Women in Computing at the University of Washington is a group of students in the Paul G. Allen School (of all genders and orientations) dedicated to cultivating a strong, supportive community of women within the Allen School. We strive to help members succeed academically, socially and professionally, and we believe in demonstrating the importance and necessity of diversity in computing.
            </p>
          </div>
        </div>
        <div id='get-involved' onClick={handleClick}>
          <p>how to join</p>
        </div>
      </div>

      {/* Join Section */}
    <div className='join-section' ref={ref}>
      <p className='join-title'>Not a WiC member?</p>
      
      <div className='join-body'>
        <div className='join-left'>
          <p className='join-text'>
            Join <a href='http://tinyurl.com/wic-membership-form' target='_blank' rel="noreferrer">using this form</a> and sign up for 
            our <a href='https://mailman.cs.washington.edu/mailman/listinfo/wic' target='_blank' rel="noreferrer">mailing list</a> to 
            get updates on events and opportunities! Follow us on our Facebook and Instagram page! Join our Discord server!
          </p>
        </div>

          <div className='join-right'>
            <div className='socials'>
              <div className='social-item'>
                <a id='insta' href='https://www.instagram.com/uw.wic/' target='_blank' rel="noreferrer"><RiInstagramFill/></a>
                <a className='social-label' href='https://www.instagram.com/uw.wic/' target='_blank' rel="noreferrer">Instagram</a>
              </div>
              <div className='social-item'>
                <a id='fbook' href='https://www.facebook.com/uwwic' target='_blank' rel="noreferrer"><BsFacebook/></a>
                <a className='social-label' href='https://www.facebook.com/uwwic' target='_blank' rel="noreferrer">Facebook</a>
              </div>
              <div className='social-item'>
                <a id='discord' href='https://discord.gg/Zp4GVB7ddq' target='_blank' rel="noreferrer"><BsDiscord/></a>
                <a className='social-label' href='https://discord.gg/Zp4GVB7ddq' target='_blank' rel="noreferrer">Discord</a>
              </div>
            </div>
            <a href="mailto:wic-officers@cs.washington.edu" className='wicEmail'>
              wic-officers@cs.washington.edu
            </a>
          </div>
        </div>

        <Link to="/involved">
          <button className="wic-action-button">FAQs + List of Links</button>
        </Link>
      </div>
        

      <div className='home__container'>
        <div className='home-content'>
        <p><strong className='wic-title'>Upcoming Events</strong></p>
        <p>From career panels to fun potlucks, WiC offers several events helping you get more involved in our community! Check out our dynamic calendar for regular updates on upcoming events.</p>

        <Link to="/event">
          <button className="wic-events-button">See WiC Events Calendar</button>
        </Link>
    
        </div>
      </div>

      <div className="divider"></div>
      <div className='home__container'>
        <div className='home-content'>
        <p><strong className='wic-title'>WiC Blog</strong></p>
        <p>Get a taste of past WiC events and relive memories through our WiC blog!</p>
        <Link to="/blog">
          <button className="wic-events-button">See WiC Blog</button>
        </Link>
        </div>
      </div>

      <div className="divider"></div>
      <div className='home__container'>
        <div className='home-content'>
        <p><strong className='wic-title'>WiC Resources</strong></p>
        <p>Looking for Resources on Academics, Community, Career, and Mental Health? Check out our Resources page curated by our WiC leadership team!</p>
        <Link to="/resources">
          <button className="wic-events-button">See WiC Resources Page</button>
        </Link>
        </div>
      </div>
    </div>
  )
}

export default Home
